<template>
  <div class="certificateDetail">
    <div v-html="topHtml"></div>
    <div class="content">
      <v-btn outlined @click="backToOverview_click">
        <v-icon left>mdi-arrow-left</v-icon>
        Back to overview
      </v-btn>

      <v-btn
        outlined
        v-show="certificateLoaded"
        @click="print_click"
        color="primary"
        class="float-right"
      >
        <v-icon left>mdi-printer</v-icon>
        Print
      </v-btn>

      <br /><br />

      <v-divider></v-divider>
      <div id="certifcatePrint" v-html="certificateHtml"></div>
      <div class="text-center">
        <v-progress-circular
          class="loader"
          v-show="!certificateLoaded"
          :size="150"
          :width="7"
          color="purple"
          indeterminate
        ></v-progress-circular>
      </div>

      <v-divider></v-divider>
    </div>
    <div v-html="bottomHtml"></div>
  </div>
</template>

<script>
import services from "@/services/services";
import Axios from "axios";
import store from "@/store/index.js";

export default {
  name: "CertificateDetail",
  data: () => {
    return {
      certificateHtml: "",
      certificateUrl: "",
      certificateLoaded: false
    };
  },
  methods: {
    print_click() {
      this.$htmlToPaper("certifcatePrint");
    },
    backToOverview_click() {
      this.$router.push({ name: "CertificateOverview" });
    }
  },
  computed: {
    topHtml() {
      return store.state.viewConfiguration.certificateDetail.topHtml;
    },
    bottomHtml() {
      return store.state.viewConfiguration.certificateDetail.bottomHtml;
    }
  },
  mounted() {
    this.certificateUrl = this.$route.params.certificateUrl;
    Axios.get(this.certificateUrl).then(resp => {
      this.certificateHtml = resp.data;
      this.certificateLoaded = true;
    });
  }
};
</script>

<style lang="scss" scoped>
.certificateDetail {
  .content {
    width: 800px;
    margin: 0 auto;
  }
  .loader {    
    margin: 50px auto;
  }

  #certifcatePrint{
      background-color: #fff;
  }
}
</style>
